<udx-spinner
  [backdrop]="true"
  theme="gds-default"
  [data]="{ label: pageLabels?.['com.udx.loading'] }"
></udx-spinner>
<upr-notification
  data-aui="notification-message"
  [ngClass]=""
></upr-notification>
<!-- <upr-k2-layout
[globalNavigation]="globalNavigation"
[footerSignUp]="true"
[notificationClass]="{ 'collapse-nav': isStickyNavOpen }"
>
<router-outlet></router-outlet>
</upr-k2-layout> -->
<div class="app-layout">
  @if (showNav) {
    <gds-global-nav
      [data]="navRegularData"
      (globalNavLoaded)="loadGdsNav()"
      (gdsComponentLoaded)="componentLoaded()"
      (buttonElementClick)="globalNavButtonElementClicked($event)"
      class="header-nav"
    ></gds-global-nav>
  }
  <div class="app-layout-content">
    <router-outlet></router-outlet>
  </div>
  @if (showFooter) {
    <gds-footer class="footer-nav" [data]="footerRegularData"></gds-footer>
  }
</div>
